module.exports = __webpack_public_path__ + "static/media/AvenirNext-MediumItalic.2767ed98.woff";